import React, { CSSProperties, PropsWithChildren } from 'react';
import { Node, useEditor, useNode } from '@craftjs/core';
import { BlockProps } from '../../types/props';
import { useMediaQuery } from '@mui/material'
import { getStyle, getBorder } from '../../services/HelperService';

export const LandingPageContainer = (
  props: PropsWithChildren<
    BlockProps & {
      rowStart?: number;
      colStart?: number;
      rowSpan?: number;
      colSpan?: number;
      mobileStyle?: CSSProperties;
      border?: any;
    }
  >
) => {
  const { connectors: { connect }, id, parent } = useNode(node => ({ id: node.id, parent: node.data.parent }));
  const mobile = useMediaQuery('(max-width:500px)')
  const {query: {node}} = useEditor()
  let parentNode: Node = node(parent).get()

  const gridPlacement: CSSProperties = {
    gridColumnStart: props.colStart ?? 1,
    gridColumnEnd: `span ${props.colSpan ?? 1}`,
    gridRowStart: props.rowStart ?? 1,
    gridRowEnd: `span ${props.rowSpan ?? 1}`,
  };

  const style: CSSProperties = {                  
    position: 'relative',
    width: '100%',
    // minHeight: '90px',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(229, 229, 229, 1)',
    ...gridPlacement,
    ...getBorder(props.border),
    ...getStyle(props.style, props.mobileStyle, parentNode, mobile)
  };

  return (
    <div
      id={id}
      ref={ref => connect(ref)}
      className="dm-edit-landing-page-container"
      style={style}
    >
      {props.children}
    </div>
  );
};

LandingPageContainer.craft = {
  name: "LandingPageContainer",
  displayName: "LandingPageContainer",
};
